<template>
  <div class="root" @click="onClick">
    <div>
      <svg
        v-if="type === 'home'"
        width="46"
        height="47"
        viewBox="0 0 46 47"
        :fill="current ? '#5cd5d6' : '#606060'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="&#229;&#144;&#136;&#228;&#189;&#147; 1"
          d="M7.59918 46.4758C5.66418 46.4668 3.84796 45.709 2.48175 44.3401C1.11646 42.9722 0.362305 41.1531 0.357788 39.22V16.3833C0.373962 13.7319 1.83105 11.3037 4.16028 10.043L19.5152 1.65137C20.5745 1.07349 21.7724 0.769287 22.9784 0.769287C24.1844 0.769287 25.3813 1.07349 26.4407 1.65039L41.8406 9.99878C44.1689 11.2598 45.626 13.688 45.6422 16.3367V39.219C45.6332 43.2205 42.3716 46.4758 38.3711 46.4758H7.59918ZM21.4079 5.11084L6.00885 13.4746C4.95496 14.0579 4.30249 15.1719 4.30878 16.3806V39.219C4.30878 41.0415 5.79199 42.5247 7.6145 42.5247H38.3711C40.1855 42.5186 41.6624 41.0352 41.6624 39.219V16.3833C41.6633 15.1685 41.0009 14.0532 39.9326 13.4746L24.5615 5.12524C24.0773 4.85889 23.5319 4.7168 22.9828 4.71313C22.4348 4.71313 21.8903 4.85083 21.4079 5.11084ZM22.9811 39.9993C20.8202 39.9993 18.7088 39.2424 17.0384 37.8665C15.3689 36.4912 14.2205 34.5642 13.8065 32.4412L13.8029 32.4197C13.7156 31.8455 13.8839 31.2659 14.2646 30.8274C14.6399 30.3965 15.1835 30.1489 15.7559 30.1489H15.7721H15.7937C16.754 30.1489 17.5703 30.8328 17.7386 31.7778C17.9924 32.9849 18.6602 34.0774 19.6178 34.855C20.5771 35.6343 21.7859 36.0637 23.0225 36.0637C24.2582 36.0637 25.4678 35.6343 26.4272 34.855C27.3848 34.0774 28.0517 32.9849 28.3064 31.7778C28.4747 30.8328 29.291 30.1489 30.2513 30.1489H30.2729H30.2891C30.8606 30.1489 31.4042 30.3965 31.7795 30.8274C32.1611 31.2659 32.3293 31.8462 32.2421 32.4204L32.2385 32.4412C31.3835 36.8206 27.5243 40.0002 23.0612 40.0002C23.0342 40.0002 23.0081 39.9993 22.9811 39.9993Z"
        />
      </svg>
      <svg
        v-if="type === 'sight'"
        width="54"
        height="41"
        viewBox="0 0 54 41"
        :fill="current ? '#5cd5d6' : '#606060'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="&#227;&#131;&#145;&#227;&#130;&#185; 9422"
          d="M53.0715 25.9817C52.9814 25.72 47.0732 10.175 47.0453 10.1091C46.2331 8.01681 44.605 6.38163 42.6122 5.51287C42.5897 5.45436 41.8094 3.43005 41.784 3.3727C40.8758 1.32385 38.8295 0 36.5709 0C34.0383 0 31.7876 1.69946 31.0981 4.13251C31.0584 4.27218 31.0384 4.41636 31.0384 4.56138V11.6394H22.6496V4.56138C22.6496 4.41636 22.6296 4.27218 22.5903 4.13251C21.9004 1.69946 19.6497 0 17.117 0C14.6189 0 12.5737 1.62899 11.8745 3.44358L11.0758 5.51329C8.98844 6.42305 7.39384 8.12702 6.61966 10.166C0.217478 27.0165 0.710632 25.7082 0.616468 25.9813C0.207307 27.1676 0 28.4104 0 29.6752C0 35.9197 5.08033 41 11.3248 41C16.9262 41 21.5903 36.9117 22.4915 31.5627H31.1965C32.098 36.9117 36.7618 41 42.3632 41C48.6076 41 53.688 35.9197 53.688 29.6752C53.688 28.4104 53.4807 27.1676 53.0715 25.9817ZM44.1265 11.2831C44.1331 11.3007 44.14 11.3179 44.1474 11.3355L47.2297 19.4482C42.8805 17.3727 37.6093 18.2713 34.1841 21.8505V13.1074C34.1841 10.2741 36.4889 7.96931 39.3222 7.96931C41.4436 7.96931 43.3745 9.30092 44.1265 11.2831ZM31.0384 24.0128H22.6496V14.7852H31.0384V24.0128ZM22.6496 27.1586H31.0384V28.4169H22.6496V27.1586ZM36.5709 3.14578C37.5622 3.14578 38.5386 3.69545 38.9774 4.83213C37.171 4.90668 35.5133 5.56247 34.1841 6.61683V4.80717C34.5479 3.82002 35.5031 3.14578 36.5709 3.14578ZM17.117 3.14578C18.1849 3.14578 19.1401 3.82002 19.5038 4.80717V6.61683C18.1746 5.56247 16.517 4.90668 14.7106 4.83255C15.1415 3.716 16.1028 3.14578 17.117 3.14578ZM9.56149 11.2831C10.3134 9.30092 12.2444 7.96931 14.3657 7.96931C17.199 7.96931 19.5038 10.2741 19.5038 13.1074V21.8505C16.0791 18.2717 10.8078 17.3723 6.45829 19.4482C11.0483 7.36721 8.98676 12.7916 9.56149 11.2831ZM11.3248 37.8542C6.81502 37.8542 3.14578 34.185 3.14578 29.6752C3.14578 25.0708 6.91904 21.4962 11.3248 21.4962C15.8346 21.4962 19.5038 25.1654 19.5038 29.6752C19.5038 34.185 15.8346 37.8542 11.3248 37.8542ZM42.3632 37.8542C37.8534 37.8542 34.1841 34.185 34.1841 29.6752C34.1841 25.1654 37.8534 21.4962 42.3632 21.4962C46.7939 21.4962 50.5422 25.09 50.5422 29.6752C50.5422 34.185 46.873 37.8542 42.3632 37.8542Z"
        />
      </svg>
      <svg
        v-if="type === 'jyutai'"
        width="54"
        height="45"
        viewBox="0 0 54 45"
        :fill="current ? '#5cd5d6' : '#606060'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2063"
        >
          <g
            id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2061"
          >
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9417"
              d="M9.44468 21.3879C9.44468 22.2575 8.74016 22.962 7.87053 22.962C7.0009 22.962 6.29639 22.2575 6.29639 21.3879C6.29639 20.5182 7.0009 19.8137 7.87053 19.8137C8.74016 19.8137 9.44468 20.5182 9.44468 21.3879Z"
            />
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9418"
              d="M50.3698 23.4917L47.9836 13.9457C47.4566 11.8398 45.5731 10.3689 43.4022 10.3689H33.4992L32.0322 4.50081C31.5053 2.39495 29.6218 0.924072 27.4508 0.924072H10.3286C8.1577 0.924072 6.27419 2.39495 5.74724 4.50137L3.36097 14.0468C1.37895 14.9618 0 16.9666 0 19.2891V23.4868C0 25.725 1.28114 27.6682 3.14829 28.6252V31.8822C3.14829 33.9074 4.79617 35.5552 6.82129 35.5552H8.92015C10.9453 35.5552 12.5932 33.9074 12.5932 31.8822V29.2587H15.7414V32.9317C15.7414 35.1699 17.0226 37.113 18.8897 38.0701V41.3271C18.8897 43.3522 20.5376 45.0001 22.5627 45.0001H24.6616C26.6867 45.0001 28.3346 43.3522 28.3346 41.3271V38.7035H41.1376V41.3271C41.1376 43.3522 42.7855 45.0001 44.8106 45.0001H46.9095C48.9346 45.0001 50.5825 43.3522 50.5825 41.3271V38.0701C52.4496 37.113 53.7308 35.1699 53.7308 32.9317V28.734C53.7308 26.4115 52.3518 24.4067 50.3698 23.4917ZM44.9293 14.7094L46.9921 22.9621H22.4802L24.5429 14.7098C24.7184 14.0075 25.3465 13.5172 26.0701 13.5172H43.4022C44.1257 13.5172 44.7538 14.0075 44.9293 14.7094ZM8.8015 5.26493C8.97696 4.56265 9.60508 4.07236 10.3286 4.07236H27.4508C28.1744 4.07236 28.8025 4.56265 28.978 5.26451L30.2537 10.3689H26.0701C24.05 10.3689 22.2791 11.6429 21.6182 13.5172H6.73874L8.8015 5.26493ZM3.14829 19.2891C3.14829 17.8423 4.32505 16.6655 5.77186 16.6655H20.8088L20.0217 19.8138H14.1673C13.2977 19.8138 12.5932 20.5183 12.5932 21.3879C12.5932 22.2576 13.2977 22.9621 14.1673 22.9621H19.2346L19.1024 23.4917C17.9266 24.0345 16.9641 24.9609 16.3749 26.1104H5.77186C4.32505 26.1104 3.14829 24.9336 3.14829 23.4868V19.2891ZM9.44487 31.8822C9.44487 32.1713 9.20923 32.407 8.92015 32.407H6.82129C6.53221 32.407 6.29658 32.1713 6.29658 31.8822V29.2587H9.44487V31.8822ZM25.1863 41.3271C25.1863 41.6162 24.9507 41.8518 24.6616 41.8518H22.5627C22.2737 41.8518 22.038 41.6162 22.038 41.3271V38.7035H25.1863V41.3271ZM46.9095 41.8518H44.8106C44.5216 41.8518 44.2859 41.6162 44.2859 41.3271V38.7035H47.4342V41.3271C47.4342 41.6162 47.1986 41.8518 46.9095 41.8518ZM50.5825 32.9317C50.5825 34.3785 49.4057 35.5552 47.9589 35.5552H21.5133C20.0665 35.5552 18.8897 34.3785 18.8897 32.9317V28.734C18.8897 27.2871 20.0665 26.1104 21.5133 26.1104H47.9589C49.4057 26.1104 50.5825 27.2871 50.5825 28.734V32.9317Z"
            />
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9419"
              d="M25.1864 30.8329C25.1864 31.7026 24.4819 32.4071 23.6122 32.4071C22.7426 32.4071 22.0381 31.7026 22.0381 30.8329C22.0381 29.9633 22.7426 29.2588 23.6122 29.2588C24.4819 29.2588 25.1864 29.9633 25.1864 30.8329Z"
            />
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9420"
              d="M47.4344 30.8329C47.4344 31.7026 46.7299 32.4071 45.8603 32.4071C44.9907 32.4071 44.2861 31.7026 44.2861 30.8329C44.2861 29.9633 44.9907 29.2588 45.8603 29.2588C46.7299 29.2588 47.4344 29.9633 47.4344 30.8329Z"
            />
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9421"
              d="M39.5634 29.2588H29.9086C29.039 29.2588 28.3345 29.9633 28.3345 30.8329C28.3345 31.7026 29.039 32.4071 29.9086 32.4071H39.5634C40.433 32.4071 41.1375 31.7026 41.1375 30.8329C41.1375 29.9633 40.433 29.2588 39.5634 29.2588Z"
            />
          </g>
        </g>
      </svg>
      <svg
        v-if="type === 'notifi'"
        width="42"
        height="46"
        viewBox="0 0 42 46"
        :fill="current ? '#5cd5d6' : '#606060'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2074"
        >
          <g
            id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2073"
          >
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9429"
              d="M20.7107 41.3864C19.0058 41.3762 17.3022 41.2731 15.6084 41.0767C15.963 43.6229 18.1398 45.5178 20.7107 45.5178C23.2815 45.5178 25.4584 43.6229 25.8129 41.0767C24.1192 41.2731 22.4156 41.3762 20.7107 41.3864Z"
            />
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9430"
              d="M20.7107 39.3208C13.499 39.3208 3.14839 37.233 0.614946 34.5397C0.0214394 33.9087 -0.115487 32.9744 0.271979 32.1996C2.71051 27.3511 4.04699 22.0236 4.18522 16.5983C4.08545 12.1857 5.79449 7.92385 8.9154 4.80293C12.0363 1.68155 16.2982 -0.0271351 20.7107 0.0727492C25.1233 -0.0271351 29.3852 1.68155 32.5061 4.80293C35.627 7.92385 37.336 12.1857 37.2363 16.5983C37.3745 22.0236 38.711 27.3511 41.1495 32.1996C41.537 32.9744 41.4001 33.9087 40.8065 34.5397C38.2731 37.233 27.9225 39.3208 20.7107 39.3208ZM4.75435 32.373C9.87377 34.2138 15.2705 35.1661 20.7107 35.1893C26.151 35.1661 31.5477 34.2138 36.6671 32.373C34.4283 27.4089 33.2166 22.0432 33.1048 16.5983C33.1801 13.2887 31.8986 10.0919 29.5576 7.75141C27.2171 5.41041 24.0203 4.12883 20.7107 4.20422C17.4012 4.12883 14.2044 5.41041 11.8639 7.75141C9.52288 10.0919 8.24142 13.2887 8.31669 16.5983C8.20485 22.0432 6.99322 27.4089 4.75435 32.373Z"
            />
          </g>
        </g>
      </svg>
      <svg
        v-if="type === 'mypage'"
        width="40"
        height="46"
        viewBox="0 0 40 46"
        :fill="current ? '#5cd5d6' : '#606060'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2072"
        >
          <g
            id="&#227;&#130;&#176;&#227;&#131;&#171;&#227;&#131;&#188;&#227;&#131;&#151; 2071"
          >
            <path
              id="&#227;&#131;&#145;&#227;&#130;&#185; 9428"
              d="M29.5511 26.5591C34.396 22.5235 36.1941 15.8853 34.0481 9.95574C31.9026 4.02684 26.2723 0.0771484 19.9668 0.0771484C13.6614 0.0771484 8.03104 4.02684 5.88554 9.95574C3.73957 15.8853 5.53768 22.5235 10.3826 26.5591C4.07589 29.3584 0.00795554 35.6072 0 42.5073C0 43.8856 1.11752 45.0032 2.49585 45.0032C3.87419 45.0032 4.99171 43.8856 4.99171 42.5073C4.99171 35.615 10.5787 30.028 17.471 30.028H22.4627C29.355 30.028 34.942 35.615 34.942 42.5073C34.942 43.8856 36.0595 45.0032 37.4378 45.0032C38.8162 45.0032 39.9337 43.8856 39.9337 42.5073C39.9257 35.6072 35.8578 29.3584 29.5511 26.5591ZM19.9668 5.06948C24.005 5.06948 27.6452 7.50201 29.1904 11.2324C30.7357 14.9627 29.8815 19.2567 27.0261 22.1121C24.1706 24.9675 19.8767 25.8217 16.1463 24.2765C12.4159 22.7312 9.98342 19.091 9.98342 15.0529C9.98342 9.53893 14.4529 5.06948 19.9668 5.06948Z"
            />
          </g>
        </g>
      </svg>
    </div>
    <span class="text-link" :class="{ green: current }">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: "text-link-inline",
  props: {
    text: { type: String },
    current: { type: Boolean, default: false },
    type: { type: String },
  },
  methods: {
    onClick() {
      this.$emit("click-text", this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.root {
  height: 2rem;
  width: 100%;
  .text-link {
    color: #373737;
    margin: 0;
    text-align: center;
    &.green {
      color: #5cd5d6;
    }
  }
  svg {
    height: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/IconLink.vue